<template>
<div class="chapter">
<div class="inner_page">
<div class="fs" id="page016">
<div class="jstfy" id="page016_1">BRIOCHES</div>
<div class="jstfy" id="page016_2">TIME REQUIRED: <span class="page016_2a">1 hour</span></div>
<div class="jstfy" id="page016_3">B<span class="small">rioches are believed</span> to have originated in Normandy. What</div>
<div class="jstfy" id="page016_4">makes these brioches special is that a small ball of yeast dough is</div>
<div class="jstfy" id="page016_5">Makes 30 brioches</div>
<div class="jstfy" id="page016_6">set on top of a larger one like a pyramid.</div>
<div class="jstfy" id="page016_7">500 g plain flour</div>
<div class="jstfy" id="page016_8">1.</div>
<div class="jstfy" id="page016_8a"><span class="page016_8a"> Grease the brioche moulds well with margarine at room</span></div>
<div class="jstfy" id="page016_9">30 g fresh yeast</div>
<div class="jstfy" id="page016_10">temperature.</div>
<div class="jstfy" id="page016_11">2.</div>
<div class="jstfy" id="page016_11a"><span class="page016_11a"> To make the sponge starter, sift some flour into a bowl, make a</span></div>
<div class="jstfy" id="page016_12">6 tablespoons lukewarm</div>
<div class="jstfy" id="page016_13">well and crumble the yeast into it. Mix with soya milk, sugar and</div>
<div class="jstfy" id="page016_14">soya milk</div>
<div class="jstfy" id="page016_15">a little more flour. Cover with a cotton cloth and rest in a warm</div>
<div class="jstfy" id="page016_16">2 tsp sugar</div>
<div class="jstfy" id="page016_17">place for about 15 minutes.</div>
<div class="jstfy" id="page016_18">150 g high-quality vegan</div>
<div class="jstfy" id="page016_19">3.</div>
<div class="jstfy" id="page016_19a"><span class="page016_19a"> Melt the margarine and leave it to cool. Mix it with the flour,</span></div>
<div class="jstfy" id="page016_20">margarine</div>
<div class="jstfy" id="page016_21">soya yoghurt and salt. Mix all the ingredients together. Knead the</div>
<div class="jstfy" id="page016_22">4 tbsp soya yoghurt</div>
<div class="jstfy" id="page016_23">dough with your hands until it becomes elastic. Cover again and</div>
<div class="jstfy" id="page016_24">½ tsp salt</div>
<div class="jstfy" id="page016_25">leave to rise for 15 minutes.</div>
<div class="jstfy" id="page016_26">Vegan cream, for glazing</div>
<div class="jstfy" id="page016_27">4.</div>
<div class="jstfy" id="page016_27a"><span class="page016_27a"> Knead the dough well, divide in half and roll each half into a</span></div>
<div class="jstfy" id="page016_28">Vegan margarine, for</div>
<div class="jstfy" id="page016_29">sausage. Cut both sausages into 15 pieces of uniform size. Roll each</div>
<div class="jstfy" id="page016_30">greasing</div>
<div class="jstfy" id="page016_31">piece into a large and a small ball. Put each of the large balls into the</div>
<div class="jstfy" id="page016_32">moulds and press down with your thumb to make an indentation.</div>
<div class="jstfy" id="page016_33">Brush inside with a little vegan cream (you can also add a little</div>
<div class="jstfy" id="page016_34">jam if you like). Gently press a small ball into the indentation.</div>
<div class="jstfy" id="page016_35">Glaze the brioches with the vegan cream. Rest them for 10 more</div>
<div class="jstfy" id="page016_36">minutes.</div>
<div class="jstfy" id="page016_37">5.</div>
<div class="jstfy" id="page016_37a"><span class="page016_37a">Preheat the oven to 220°C/425°F/gas 7. Put the moulds on a</span></div>
<div class="jstfy" id="page016_38">baking tray and, with the oven shelf on the second position from</div>
<div class="jstfy" id="page016_39">the bottom, bake for 15–20 minutes, until golden. Transfer to a</div>
<div class="jstfy" id="page016_40">rack and leave to cool.</div>
<div class="jstfy" id="page016_41">Tip:</div>
<div class="jstfy" id="page016_41a"><span class="page016_41a">If you don’t have brioche moulds, you can shape the brioches</span></div>
<div class="jstfy" id="page016_42">and place them directly on the baking sheet. They may not look</div>
<div class="jstfy" id="page016_43">as nice when they’re done, but they’ll taste just as good!</div>
<div class="jstfy" id="page016_44">B<span class="pagen">asics</span></div>
<div class="jstfy" id="page016_0">16</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// page_016.vue?1deac0e8